<template>
    <label class="flex items-start gap-x-3 cursor-pointer text-sm/6">
        <span class="flex h-lh items-center">
            <input type="checkbox" v-model="modelValue" :value="value" v-bind="$attrs" :aria-invalid="hasError" :aria-describedby="errorId" />
        </span>
        <slot />
    </label>
</template>

<script setup>
defineOptions({
    inheritAttrs: false
})

const modelValue = defineModel()

const props = defineProps({
    value: {
        type: [String, Number, Object, Boolean],
        default: 1
    },
    checked: {
        type: [String, Number, Object, Boolean],
        default: 0
    },
    hasError: {
        type: Boolean,
        default: false
    },
    errorId: {
        type: String,
        default: null
    }
})

// on mounted checked is always false
onMounted(() => {
    if (Array.isArray(modelValue.value) && props.checked == props.value && !modelValue.value.includes(props.value)) {
        modelValue.value.push(props.value)
    }
})
</script>
